import React from "react";
import { useLang } from "../i18n/LanguageContext";

export default function Legal() {
  const { t } = useLang();
  const sections = [
    { key: "editor", title: "legal.editorTitle", text: "legal.editorText" },
    { key: "hosting", title: "legal.hostingTitle", text: "legal.hostingText" },
    { key: "ip", title: "legal.ipTitle", text: "legal.ipText" },
    { key: "responsibility", title: "legal.responsibilityTitle", text: "legal.responsibilityText" },
  ];

  return (
    <div>
      <section className="border-b border-border-light">
        <div className="container-notary py-20 md:py-24">
          <div className="overline mb-4">{t("legal.eyebrow")}</div>
          <h1 className="text-4xl md:text-5xl font-serif text-charcoal">{t("legal.title")}</h1>
          <span className="divider-gold my-6 block" />
        </div>
      </section>
      <section className="container-notary py-16 max-w-3xl">
        <div className="space-y-10">
          {sections.map((s) => (
            <div key={s.key} data-testid={`legal-${s.key}`}>
              <h2 className="font-serif text-2xl text-charcoal mb-3">{t(s.title)}</h2>
              <p className="text-charcoal-muted leading-relaxed">{t(s.text)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
